import axios from '../localAxios';
import { sendEmailVerificationURL } from './url';

export async function sendEmailVerification() {
  const url = sendEmailVerificationURL();
  return axios.post(url.toString());
}
